module.exports = __webpack_public_path__ + "static/media/Cabs2.0-225-50-A.f9bb3aa4.png";